import script from "./RoleList.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleList.vue?vue&type=script&setup=true&lang=js"

import "./RoleList.vue?vue&type=style&index=0&id=1de5aa01&lang=css"
import "./RoleList.vue?vue&type=style&index=1&id=1de5aa01&scoped=true&lang=css"

import exportComponent from "E:\\Java\\GongJu\\idea\\job\\job_slcj\\job_vue_boot\\job_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de5aa01"]])

export default __exports__